import React from "react";
import { TabHeader, OrnateFrame } from "@/components/royal";
import { EditableText, EditableTextarea, EditableNumber } from "@/components/fields";
import { Button } from "@/components/ui/button";
import { UserPlus, Users, User, Plus, Trash2 } from "lucide-react";

export default function Dungeon({ player, updatePlayer, editable }) {
  const captives = player.dungeon || [];

  const add = (type) => updatePlayer((p) => {
    p.dungeon = p.dungeon || [];
    p.dungeon.push({
      id: crypto.randomUUID(), type,
      name: type === "group" ? "New Group" : "New Prisoner",
      count: type === "group" ? 2 : 1, description: "",
    });
  });
  const change = (id, k, v) => updatePlayer((p) => { const c = p.dungeon.find((x) => x.id === id); if (c) c[k] = v; });
  const remove = (id) => updatePlayer((p) => { p.dungeon = p.dungeon.filter((x) => x.id !== id); });

  return (
    <div className="space-y-6">
      <TabHeader label="Held in Captivity" title="Dungeon">
        {editable && (
          <>
            <Button variant="outline" size="sm" className="rounded-sm" onClick={() => add("character")} data-testid="add-prisoner">
              <UserPlus strokeWidth={1.5} className="w-4 h-4 mr-1" /> Prisoner
            </Button>
            <Button size="sm" className="rounded-sm" onClick={() => add("group")} data-testid="add-group">
              <Users strokeWidth={1.5} className="w-4 h-4 mr-1" /> Group
            </Button>
          </>
        )}
      </TabHeader>

      {captives.length === 0 ? (
        <div className="ht-panel p-12 text-center text-muted-foreground" data-testid="dungeon-empty">The dungeons are empty.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="dungeon-grid">
          {captives.map((c, i) => {
            const isGroup = c.type === "group";
            const Icon = isGroup ? Users : User;
            return (
              <OrnateFrame key={c.id} hover className="px-6 pt-7 pb-6 space-y-4" testId={`captive-card-${i}`}>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 border border-gold/40 rounded-sm flex items-center justify-center shrink-0">
                    <Icon strokeWidth={1.5} className="w-5 h-5 text-gold" />
                  </div>
                  <div className="flex-1 min-w-0">
                    {editable
                      ? <EditableText value={c.name} editable onChange={(v) => change(c.id, "name", v)} placeholder={isGroup ? "Who are they?" : "Prisoner name"} testId={`captive-name-${i}`} />
                      : <h3 className="ht-title text-xl truncate">{c.name || "—"}</h3>}
                    <div className="ht-uppercase-label mt-0.5">{isGroup ? "Group" : "Prisoner"}</div>
                  </div>
                  {isGroup && (
                    <div className="text-right shrink-0">
                      {editable ? (
                        <div className="w-20"><EditableNumber label="Count" value={c.count} editable min={1} onChange={(v) => change(c.id, "count", v)} testId={`captive-count-${i}`} /></div>
                      ) : (
                        <div>
                          <div className="ht-title text-3xl leading-none tabular-nums" data-testid={`captive-count-${i}`}>{c.count ?? 0}</div>
                          <div className="ht-uppercase-label">held</div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <EditableTextarea value={c.description} editable={editable} rows={2} onChange={(v) => change(c.id, "description", v)} placeholder="Notes on this captive…" testId={`captive-desc-${i}`} />
                {editable && (
                  <Button variant="ghost" size="sm" className="rounded-sm text-destructive" onClick={() => remove(c.id)} data-testid={`captive-remove-${i}`}>
                    <Trash2 strokeWidth={1.5} className="w-4 h-4 mr-1" /> Release
                  </Button>
                )}
              </OrnateFrame>
            );
          })}
        </div>
      )}
    </div>
  );
}
